import { GTM_EVENT_ACTIONS, GTM_EVENT_CATEGORIES, GTM_EVENTS } from './events';
import { pushEventToDataLayer } from './utils';
import { useQuery } from '@tanstack/react-query';
import { getUserInfo } from 'api/requests/core/users';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { queryKeyBuilder } from 'shared/query';

export function usePageViewEvent() {
  const { data: userData } = useQuery({
    queryKey: queryKeyBuilder.currentUser(),
    queryFn: getUserInfo,
  });

  useEffect(() => {
    if (userData) {
      pushEventToDataLayer(GTM_EVENTS.PAGE_VIEW, {
        user_id: userData?.id?.toString(),
        user_hashed_email: userData?.attributesEmail,
        page_path: window.location.pathname,
      });
    }
  }, [userData]);
}

export function useFiltersChangeEvent() {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    pushEventToDataLayer(GTM_EVENTS.CUSTOM_EVENT, {
      event_category: GTM_EVENT_CATEGORIES.FILTERING,
      event_action: GTM_EVENT_ACTIONS.FILTERS_APPLIED,
      filters: searchParams.toString(),
    });
  }, [searchParams]);
}
